const riot = require('riot');

riot.tag2('module-thanks-amazon_gift_card', '<div class="bg-grad_light_blue w-full h180 pt24"> <div class="text-center ts-hl text-white">ありがとうございました</div> </div> <div class="px24 mtn105"> <div class="w-full pb20 pt30 rounded-8 elevation-default-mid text-center bg-white mb24"> <div class="f fh mb24"><img class="block h70 object-fit-contain" riot-src="/images/{opts.event.point_provider}/logo.svg"></div> <div class="ts-hs text-gray_80 mb4">Amazonギフトカード</div> <div class="f fc fb"> <div class="fs40 text-gray_80 mr8">{opts.event.amount.toLocaleString()}</div> <div class="ts-hs text-gray_60">円分</div> </div> </div> <div class="border-bottom border-bottom pb24 mb24"> <div class="ts-ps text-gray_80 mb24">下に記載しているURLからAmazonギフトカードをお受け取りください。</div> <div class="ts-ps text-gray_80">このページは {dayjs(opts.event.expires_at).format(\'YYYY年M月D日 HH時mm分\')} 以降は閲覧できなくなります。</div> </div> <div class="mb24"> <div class="text-gray_80 ts-pxs" data-is="atom-anchorify" text="{description}"></div> </div> </div>', '', '', function(opts) {
    const event = this.opts.event;

    var description = `この度は、${event.campaign_display_name}にご応募いただき、誠にありがとうございます。
    ${event.campaign_display_company_name} ${event.campaign_display_name}運営事務局でございます。
    以下の通り、Amazonギフトカードをお送りいたします。

    ■Amazonギフトカード
    （＊Amazonギフトカードの再発行は致しかねます。このメッセージをプリントアウトすることをお勧めいたします。）
    （＊入力間違い防止の為、メールの場合はコピー＆ペーストをお勧めいたします。）
    --------------------------------------------------------
    ギフトカード番号 : ${event.ntt_card_solutions_distribution.gift_id}（＊ハイフンも含みます）
    金額 : ${event.amount.toLocaleString()}円
    有効期限 : ${dayjs(event.ntt_card_solutions_distribution.expires_at).format('YYYY/MM/DD')}
    --------------------------------------------------------

    ■Amazonギフトカードのご利用方法
    Amazonギフトカードをご利用いただくには、最初にアカウントにギフトカードを登録します。
    1.https://www.amazon.co.jp/giftcard/use にアクセスして下さい。
    2.サインインします。
    3.ギフトカ－ド番号を入力し、「アカウントに登録する」をクリックします。

    ■Amazonギフトカード　細則
    Amazon Gift Cards Japan合同会社 (「当社」) が発行するAmazonギフトカード (「ギフトカード」)のご利用には、https://www.amazon.co.jp (PC・モバイルを含み「アマゾンサイト」) のアカウント作成が必要です。ギフトカードは、アマゾンサイトまたは一部のAmazon Pay加盟店でご利用できますが、他のギフトカードの購入又は一部の会費の支払等には利用できません。このギフトカードの有効期限は発行日から10年間です。ギフトカードの換金・返金等はできません。当社及び当社の関連会社は、ギフトカードの紛失・盗難等について一切責任を負いません。ギフトカードに関するお問合せは、カスタマーサービス(東京都目黒区下目黒1-8-1, https://amazon.co.jp/contact-us )までお願いします。詳細は、細則( https://www.amazon.co.jp/giftcard/tc )をご覧下さい。

    本キャンペーンは${this.opts.event.campaign_display_company_name}による提供です。
    本キャンペーンについてのお問い合わせはAmazonではお受けしておりません。
    ${this.opts.event.contact_name}（ ${this.opts.event.contact_email} ）までお願いいたします。
    Amazon、Amazon.co.jpおよびそれらのロゴはAmazon.com, Inc.またはその関連会社の商標です。`

    this.description = description.replace(/^ +/gm, "");
});